<template>
    <v-container fluid grid-list-md>
        <v-layout row wrap>
            <v-flex
                class="mt-4 d-flex justify-center"
                xs12
                sm6
                lg4
                v-for="(item, index) in items"
                :key="index"
            >
                <v-card
                    color="#fff"
                    :class="
            item.active
              ? 'shopping_card mx-2 mb-4 active_item'
              : 'shopping_card mx-2 mb-4'
          "
                    elevation="0"
                    min-width="320px"
                    :max-width="$vuetify.breakpoint.lgAndUp ? '320px' : '100%'"
                >
                    <div class="card_logo mt-12">
                        <img :src="item.logo" :alt="item.name" />
                    </div>
                    <div class="card_title mt-5">{{ item.title }}</div>
                    <div v-if="item.followers" class="card_followers mt-6 mb-3">
                        <img src="../assets/followers_dark.svg" alt="followers" />
                        <span>{{ item.followers }} followers </span>
                    </div>
                    <div v-if="item.likes" class="card_likes mb-3">
                        <img src="../assets/like_dark.svg" alt="followers" />
                        <span>{{ item.likes }} Likes </span>
                    </div>
                    <div v-if="item.comments" class="card_comments mb-3">
                        <img src="../assets/comment_dark.svg" alt="followers" />
                        <span>{{ item.comments }} comments </span>
                    </div>
                    <div v-if="item.views" class="card_comments mb-3">
                        <img src="../assets/eye_dark.svg" alt="followers" />
                        <span>{{ item.views }} views </span>
                    </div>
                    <div class="card_comments mb-12"></div>


                    <div v-if="item.save" class="card_save">You save {{ item.save }}%</div>
                    <div class="card_price">${{ item.price }}</div>
                    <div v-if="item.discount" class="card_discount mb-9">${{ item.discount }}</div>
                    <div class="card_btn mb-4">
                        <v-btn
                            class="get_btn"
                            width="217px"
                            height="60px"
                            color="#76CD68"
                            dark
                            depressed
                        >
                            Get it Now
                        </v-btn>
                    </div>
                    <div class="card_video">
                        <v-btn
                            class="get_btn how_btn"
                            width="184px"
                            height="60px"
                            color="#FF0000"
                            dark
                            outlined
                            depressed
                        >
                            <img src="../assets/youtube.svg" alt="youtube" />
                            <span class="ml-2 mt-1">How to buy</span>
                        </v-btn>
                    </div>
                    <div class="card_terms my-8 mb-10">
                        By continuing you need to
                        <a class="ml-1" href="/terms">terms</a>
                    </div>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
    import {getProductsByType} from "@/api/social_network";

    export default {
        name: "Shop",
        data() {
            return {
                items: [],
            };
        },
        created() {
            this.$root.breadcrumbs = [
                {
                    text: "Home",
                    href: "/",
                },
                {
                    text: "Shop",
                    href: "/shop",
                    icon: "../assets/arrow.svg",
                },
            ];

            this.getProducts(this.$router.currentRoute.params.pathMatch);
        },
        methods: {
            getProducts(pathMatch){
                getProductsByType(pathMatch)
                    .then((data) => {
                        this.items = data.products;
                    })
                    .catch(error => {
                        console.log(error)
                    });
            }
        }
    };
</script>
<style scoped>
    .shopping_card {
        border-radius: 20px !important;
        overflow: hidden;
    }
    .get_btn {
        text-transform: none;
        font-size: 18px !important;
        border-radius: 40px;
        font-weight: normal;
    }
    .shopping_card > div {
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #172745;
        font-size: 18px;
    }
    .card_logo img {
        width: 62px;
    }
    .card_title {
        color: #000;
        font-weight: 600;
    }
    .shopping_card span {
        margin-left: 14px;
        margin-top: 5px;
    }
    .card_save {
        color: #000 !important;
    }
    .card_price {
        font-size: 48px !important;
        line-height: 59px;
    }
    .card_discount {
        text-decoration: line-through;
    }
    .how_btn {
        font-size: 14px !important;
    }
    .card_terms,
    .card_terms a {
        color: #afafaf !important;
        font-size: 14px !important;
    }
    .active_item {
        border: 1px solid #ffbc0f !important;
        position: relative;
    }
    .active_item::before {
        content: "active";
        display: block;
        position: absolute;
        top: 0;
        left: calc(50% - 89px);
        width: 178px;
        height: 30px;
        background-color: #ffbc0f;
        color: #fff;
        font-size: 18px;
        font-weight: bold;
        text-align: center;
        border-radius: 0px 0px 20px 20px;
    }
</style>
